/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProformaJiraExportType from '@jira/spa-apps__proforma-export/src/ProformaJiraExportWrapper.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProformaExport: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ProformaJiraExportType
>(
	() =>
		import(
			/* webpackChunkName: "async-proforma-export", jiraSpaEntry: "async-proforma-export" */ '@jira/spa-apps__proforma-export/src/ProformaExport.tsx'
		),
);

const AsyncProformaExport = (): React.JSX.Element => (
	<LazyPage Page={LazyProformaExport} pageId="proforma-export" shouldShowSpinner />
);

export default AsyncProformaExport;
